/**
 * Geometry utility functions
 */

/**
 * Calculate distance from a point to a line segment
 * @param px - Point X coordinate
 * @param py - Point Y coordinate
 * @param x1 - Line segment start X
 * @param y1 - Line segment start Y
 * @param x2 - Line segment end X
 * @param y2 - Line segment end Y
 * @returns Distance from point to the nearest point on the line segment
 */
export function pointToLineDistance(
  px: number,
  py: number,
  x1: number,
  y1: number,
  x2: number,
  y2: number
): number {
  const dx = x2 - x1
  const dy = y2 - y1
  const lengthSquared = dx * dx + dy * dy

  if (lengthSquared === 0) {
    // Line segment is a point
    return Math.sqrt(Math.pow(px - x1, 2) + Math.pow(py - y1, 2))
  }

  // Project point onto line, clamping to segment
  let t = ((px - x1) * dx + (py - y1) * dy) / lengthSquared
  t = Math.max(0, Math.min(1, t))

  // Find closest point on segment
  const closestX = x1 + t * dx
  const closestY = y1 + t * dy

  return Math.sqrt(Math.pow(px - closestX, 2) + Math.pow(py - closestY, 2))
}
